import dayjs from "dayjs";
import { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "../../config/supabaseClient";
import { shouldShowToViewer } from "./TimezoneDates";
import { sortArchivedComponents } from "../StayUpToDate/archiveSort";
import {
  fetchCreatorControls,
  fetchFollowerControls,
} from "../SupabaseServices/ControlsDatabase";
import { fetchGlobalControls } from "../SupabaseServices/GlobalControlsDatabase";
import { getPopularSearches } from "../SupabaseServices/SearchesDatabase";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getCustomAddDate, getCustomSubtractDate, getTodayDate } from "./TimezoneDates";
import { isAbortError } from "../errors/isAbortError";
import { isHiddenComponent } from "../componentsTable";
import { enrichLinksSectionEmptyState } from "../landingPageContent";
import { isProductCollectionType } from "../productCollection";
import {
  displayFeedCardTitle,
  isInstagramHandleLikeTitle,
  sanitizePublicCardTitle,
} from "../media/feedCardTitle";

dayjs.extend(utc);
dayjs.extend(timezone);
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export async function getUser(username: any) {
  const { data }: any = await supabase
    .from("user")
    .select("*")
    .eq("username", username);

  if (data.length === 0) {
    return false;
  }

  const {
    user_id,
    name,
    storage_url,
    picture,
    original_profile_url,
    image_crop,
    email,
    phoneNo,
    instagram_link,
    youtube_link,
    amazon_link,
    podcast_link,
    pinterest_user,
    twitter_link,
    newsletter_email,
    instagram_links,
    is_onboarding_finished,
    is_nec_search,
    avg_caption_words,
    is_instagram_on,
    is_youtube_on,
    is_newsletter_on,
    is_tiktok_on,
    is_twitter_on,
    is_podcast_on,
    is_pinterest_on,
    is_nec_present,
    first_connected_platform,
    subscription_type,
  } = data[0];

  const pictureUrl = storage_url || picture;
  const instaLink = instagram_link;
  const youtubeLink = youtube_link;
  const amazonLink = amazon_link;
  const podcastLink = podcast_link;
  const pinterestLink = pinterest_user;
  const twitterLink = twitter_link;
  const newsletterLink = newsletter_email;

  const activeSocials = [
    { term: "instagram", link: instaLink },
    { term: "youtube", link: youtubeLink },
    { term: "amazon", link: amazonLink },
    { term: "podcast", link: podcastLink },
    { term: "pinterest", link: pinterestLink },
    { term: "twitter", link: twitterLink },
    { term: "pinterest" },

    { term: "newsletter" },
  ].filter((social) => social.link);

  const showSocials = [
    { platform: "instagram", isOn: is_instagram_on },
    { platform: "youtube", isOn: is_youtube_on },
    { platform: "podcast", isOn: is_podcast_on },
    { platform: "newsletter", isOn: is_newsletter_on },
    { platform: "tiktok", isOn: is_tiktok_on },
    { platform: "pinterest", isOn: is_pinterest_on },
    { platform: "LTK" },
    { platform: "Amazon" },
    { platform: "ShopMy" },

    // Add other platforms here similarly
  ]
    .filter((social) => social.isOn)
    .map((social) => social.platform);

  return {
    name,
    picture: pictureUrl,
    original_profile_url: original_profile_url || null,
    image_crop: image_crop || null,
    email,
    phoneNo,
    instaLink,
    youtubeLink,
    amazonLink,
    podcastLink,
    pinterestLink,
    twitterLink,
    activeSocials,
    showSocials,
    user_id,
    instagram_links,
    isOnboardingFinished: is_onboarding_finished,
    isNecSearch: is_nec_search,
    avg_words: avg_caption_words,
    isInstagram: is_instagram_on,
    isYoutube: is_youtube_on,
    isNewsletter: is_newsletter_on,
    isTiktok: is_tiktok_on,
    isPodcast: is_podcast_on,
    is_nec_present,
    first_connected_platform,
    subscription_type,
  };
}

export async function getFeedControls(
  page: any,
  user_id: any,
  client: SupabaseClient = supabase,
  signal?: AbortSignal
) {
  let controls;
  if (page === "follower" || page === "preview") {
    controls = await fetchFollowerControls(user_id, client, signal);
  } else if (page === "creator") {
    controls = await fetchCreatorControls(user_id);
  } else if (page === "global") {
    controls = await fetchGlobalControls();
  }

  if (!controls || controls === undefined) {
    return [];
  } else if (controls) {
    return controls;
  }
  //  else {
  //   throw new Error("Failed to fetch controls");
  // }
}

export async function getFeedActiveFilters(user_id: any, username: any) {
  // const filterArray = ["All"];

  // const { data, error }: any = await supabase
  //   .from(`${username}`)
  //   .select("type")
  //   .eq("user_id", user_id);
  // const ActiveFilters = new Set<number>();
  // if (data && data.length) {
  //   data.filter((obj: any) => {
  //     if (!ActiveFilters.has(obj.type)) {
  //       ActiveFilters.add(obj.type);
  //     }
  //   });
  // }
  // // return uniqueSet;
  // if (!ActiveFilters) {
  //   return filterArray;
  // } else {
  //   ActiveFilters.forEach((filter: any) => filterArray.push(filter));
  //   return filterArray;
  // }
  // return []
  const filterArray = ["All"];

  try {
    const { data, error } = await supabase
      .from(username)
      .select("type")
      .eq("user_id", user_id);

    if (data && data.length) {
      const activeFilters = new Set(data.map((obj: any) => obj.type));
      filterArray.push(...Array.from(activeFilters) as string[]);
    }
  } catch (error) { }

  return filterArray;
}

export async function getPartialTableCount(user_id: any, username: any) {
  // const { data, error } = await supabase
  //   .from(`${username}`)
  //   .select("*")
  //   .eq("user_id", user_id);
  // if (data) {
  //   if (data.length) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // } else {
  //   return false;
  // }
  const { data, error } = await supabase
    .from("user")
    .select("subscription_type")
    .eq("user_id", user_id);

  return data?.[0]?.subscription_type !== null ||
    data?.[0]?.subscription_type !== ""
    ? true
    : false;
}
export async function getFeedTopHashtags(user_id: any, max: any) {
  // let { data: topHashtags } = await supabase
  //   .from("searches")
  //   .select("*")
  //   .eq("type", `hashtag`)
  //   .eq("user_id", user_id)
  //   .order("occurrences", { ascending: false })
  //   .range(0, max - 1);

  // if (!topHashtags) {
  //   return false;
  // } else {
  //   let topHashtagsArr: any = [];
  //   topHashtags.map((elem: any) => {
  //     topHashtagsArr.push(elem.query);
  //   });
  //   return topHashtagsArr;
  // }
  const { data: topHashtags } = await supabase
    .from("searches")
    .select("query")
    .eq("type", "hashtag")
    .eq("user_id", user_id)
    .order("occurrences", { ascending: false })
    .range(0, max - 1);

  return topHashtags ? topHashtags.map((elem: any) => elem.query) : false;
}

export async function getFeedPopularSearches(
  user_id: any,
  username: any,
  max: any
) {
  const popularSearches = await getPopularSearches(user_id, username, max);

  if (!popularSearches) {
    return false;
  } else {
    let popularSearchesArr: any = [];
    popularSearches.map((elem: any) => {
      popularSearchesArr.push(elem.query);
    });
    return popularSearchesArr;
  }
}

export async function getFeedHighlights(user_id: any, username: any) {
  // const filterArray: any = [];

  // // const Highlights = await getHighlights(user_id);

  // const { data, error }: any = await supabase
  //   .from(`${username}`)
  //   .select("*")
  //   .eq("type", "HIGHLIGHTS")
  //   .eq("user_id", user_id);

  // const Highlights = new Set<number>();
  // if (data && data.length) {
  //   data.filter((obj: any) => {
  //     if (obj.content_category && !Highlights.has(obj.content_category)) {
  //       Highlights.add(obj.content_category);
  //     }
  //   });
  // }

  // // return uniqueSet;
  // if (!Highlights) {
  //   return filterArray;
  // } else {
  //   Highlights.forEach((filter: any) => filterArray.push(filter));
  //   return filterArray;
  // }
  const filterArray: any = [];

  try {
    const { data, error }: any = await supabase
      .from(username)
      .select("content_category")
      .eq("type", "HIGHLIGHTS")
      .eq("user_id", user_id);

    if (data && data.length) {
      const highlights = new Set(
        data.map((obj: any) => obj.content_category).filter(Boolean)
      );
      filterArray.push(...highlights);
    }
  } catch (error) { }

  return filterArray;
}

export async function getCustomCategories(user_id: any, page: any) {

  let liveCategories: any = [];
  let stagingCategories: any = [];

  const { data } = await supabase
    .from("custom_categories")
    .select("*")
    .eq("user_id", user_id)
    .order("index");

  if (data && data.length) {
    data.forEach((category: any) => {
      const categoryObject = {
        name: category.category_name,
        value: category.value,
        queries: category.custom_queries,
      };

      if (category.page === "live") {
        liveCategories.push(categoryObject);
      } else if (category.page === "staging") {
        stagingCategories.push(categoryObject);
      }
    });

    return page === "live" || page === "follower" || page === "preview"
      ? liveCategories
      : stagingCategories;
  }

  return false;
}

export async function getAllCategories(user_id: any, max: any, page: any) {
  const { data: topHashtags } = await supabase
    .from("searches")
    .select("query")
    .eq("type", "hashtag")
    .eq("user_id", user_id)
    .order("occurrences", { ascending: false })
    .range(0, max - 1);
  let liveCategories: any = [];
  let stagingCategories: any = [];

  const { data: customCategories } = await supabase
    .from("custom_categories")
    .select("*")
    .eq("user_id", user_id)
    .order("index");

  if (customCategories && customCategories.length) {
    customCategories.forEach((category: any) => {
      const categoryObject = {
        name: category.category_name,
        value: category.value,
        queries: category.custom_queries,
        default: category.default_query,
      };

      if (category.page === "live") {
        liveCategories.push(categoryObject);
      } else if (category.page === "staging") {
        stagingCategories.push(categoryObject);
      }
    });

    if (page === "live" || page === "follower" || page === "preview") {
      return {
        topHashtags: topHashtags
          ? topHashtags.map((elem: any) => elem.query)
          : false,
        customCategories: liveCategories,
      };
    } else if (page === "staging" || page === "creator" || page === "preview") {
      return {
        topHashtags: topHashtags
          ? topHashtags.map((elem: any) => elem.query)
          : false,
        customCategories: stagingCategories,
      };
    }
  }

  return false;
}

/**
 * Coalesce parallel `user` reads for the same username + client.
 * Keyed by client instance so auth vs public clients never share a result.
 */
const userByUsernameInflight = new WeakMap<
  SupabaseClient,
  Map<string, Promise<any[] | null>>
>();

export async function fetchUserRowsByUsername(
  username: any,
  client: SupabaseClient = supabase,
  signal?: AbortSignal,
): Promise<any[] | null> {
  const key = String(username ?? "").trim().toLowerCase();
  if (!key) return null;

  let byUser = userByUsernameInflight.get(client);
  if (!byUser) {
    byUser = new Map();
    userByUsernameInflight.set(client, byUser);
  }

  let shared = byUser.get(key);
  if (!shared) {
    // Do not attach AbortSignal to the shared request — one RQ unmount must
    // not cancel a parallel useLoadUser / profile setup waiter.
    shared = (async () => {
      const { data, error }: any = await client
        .from("user")
        .select("*")
        .eq("username", username);
      if (error) throw error;
      return Array.isArray(data) ? data : null;
    })().finally(() => {
      byUser!.delete(key);
    });
    byUser.set(key, shared);
  }

  if (!signal) return shared;

  return new Promise<any[] | null>((resolve, reject) => {
    if (signal.aborted) {
      reject(
        signal.reason ??
          new DOMException("The operation was aborted.", "AbortError"),
      );
      return;
    }
    const onAbort = () => {
      reject(
        signal.reason ??
          new DOMException("The operation was aborted.", "AbortError"),
      );
    };
    signal.addEventListener("abort", onAbort, { once: true });
    shared!.then(
      (value) => {
        signal.removeEventListener("abort", onAbort);
        resolve(value);
      },
      (err) => {
        signal.removeEventListener("abort", onAbort);
        reject(err);
      },
    );
  });
}

export async function getUserAndCheckExistence(
  username: any,
  client: SupabaseClient = supabase,
  signal?: AbortSignal
) {
  // if (!username) {
  //   return { userExists: false };
  // }
  try{
  let userData: any = await fetchUserRowsByUsername(username, client, signal);
if(userData?.length  > 0) {
  let {
    user_id,
    name,
    storage_url,
    picture,
    original_profile_url,
    image_crop,
    email,
    phoneNo,
    instagram_link,
    youtube_link,
    amazon_link,
    podcast_link,
    pinterest_user,
    linkedin_user,

    twitter_link,
    newsletter_email,
    instagram_links,
    is_onboarding_finished,
    is_nec_search,
    avg_caption_words,
    is_instagram_on,
    is_youtube_on,
    is_newsletter_on,
    is_tiktok_on,
    is_twitter_on,

    is_podcast_on,
    is_pinterest_on,
    is_linkedin_on,

    is_nec_present,
    first_connected_platform,
    subscription_type,
    social_instagram,
    social_youtube,

    social_tiktok,
    social_twitter,

    social_podcast,
    social_pinterest,
    social_linkedin,
    social_website,

    social_newsletter,
    social_facebook,
    social_amazon,
    social_shopmy,
    social_shop,

    social_ltk,
    social_spotify,
    social_applepodcast,
    social_discord,
    social_snapchat,
    description,
    search_bar_text,
    search_bar_tags,
    brand_color,
    brand_text_color,
    social_links_order,
    is_fillout_on,
    is_contact_me,
    show_contact_page,
    show_amazon,
    show_shopmy,
    show_ltk,
    is_embed_search,
    active_campaign,

    font_family,
    primary_font_family,
    secondary_font_family,
    background_style,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    template_name,
    social_custom,
    display_name,
    url_type,
    domain,
    card_style,
    custom_colors,
  } = userData[0];
  const pictureUrl = storage_url || picture;
  search_bar_text = search_bar_text
    ? search_bar_text
    : `Search ${name} Content`
  const instaLink = instagram_link;
  const youtubeLink = youtube_link;
  const amazonLink = amazon_link;
  const podcastLink = podcast_link;
  const pinterestLink = pinterest_user;
  const linkedinLink = linkedin_user;

  const twitterLink = twitter_link;
  const newsletterLink = newsletter_email;

  const activeSocials = [
    { term: "instagram", link: instaLink },
    // { term: "instaComment", link: instaLink },

    { term: "youtube", link: youtubeLink },
    { term: "amazon", link: amazonLink },
    { term: "podcast", link: podcastLink },
    { term: "pinterest", link: pinterestLink },
    { term: "twitter", link: twitterLink },
    { term: "pinterest" },
    { term: "newsletter" },
  ].filter((social) => social.link);

  const showSocials = [
    { platform: "instagram", isOn: is_instagram_on },
    // { platform: "instaComment", isOn: is_instagram_on },

    { platform: "youtube", isOn: is_youtube_on },
    { platform: "podcast", isOn: is_podcast_on },
    { platform: "newsletter", isOn: is_newsletter_on },
    { platform: "tiktok", isOn: is_tiktok_on },
    { platform: "twitter", isOn: is_twitter_on },
    { platform: "linkedin", isOn: is_linkedin_on },

    { platform: "pinterest", isOn: is_pinterest_on },
    { platform: "LTK", isOn: true },
    { platform: "Amazon", isOn: true },
    { platform: "ShopMy", isOn: true },
    { platform: "MISC", isOn: true },
    { platform: "MISC-content", isOn: true },

    // Add other platforms here similarly
  ]
    .filter((social) => social.isOn)
    .map((social) => social.platform);

  const userExists = subscription_type ? true : false;
  const designTokens = {
    fontFamily: font_family,
    primaryFontFamily: primary_font_family,
    secondaryFontFamily: secondary_font_family,
    primaryColor: background_style || "",
    secondaryColor: button_background || "#e6e7eb",
    tertiaryColor: button_text || "",
    templateName: template_name,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    template_name,
    font_family,
    background_style,
    card_style,
    custom_colors,
  };
  return {
    name,
    picture: pictureUrl,
    original_profile_url: original_profile_url || null,
    image_crop: image_crop || null,
    email,
    phoneNo,
    instaLink,
    youtubeLink,
    amazonLink,
    podcastLink,
    pinterestLink,
    linkedinLink,
    twitterLink,
    activeSocials,
    showSocials,
    user_id,
    instagram_links,
    isOnboardingFinished: is_onboarding_finished,
    isNecSearch: is_nec_search,
    avg_words: avg_caption_words,
    isInstagram: is_instagram_on,
    isYoutube: is_youtube_on,
    isNewsletter: is_newsletter_on,
    isTiktok: is_tiktok_on,
    isPodcast: is_podcast_on,
    is_nec_present,
    first_connected_platform,
    subscription_type,
    userExists,
    social_instagram,
    social_youtube,

    social_tiktok,
    social_twitter,
    social_podcast,
    social_pinterest,
    social_linkedin,
    social_website,
    search_bar_tags,
    social_newsletter,
    social_facebook,
    social_amazon,
    social_shopmy,
    social_shop,

    social_ltk,
    social_spotify,
    social_applepodcast,
    social_discord,
    social_snapchat,
    description,
    search_bar_text,
    brand_color,
    brand_text_color,
    social_links_order,
    is_fillout_on,
    is_contact_me,
    show_contact_page,
    show_amazon,
    show_shopmy,
    show_ltk,
    is_embed_search,
    active_campaign,
    designTokens,
    social_custom,
    display_name,
    url_type,
    domain,
    card_style,
    custom_colors,
  }
}
  } catch (error) {

    // if (!isAbortError(error)) {
    //   console.error("Error fetching user data:", error);
    // }
    return { userExists: false };
    // throw error;
  }
}

/** Columns on `user` needed for design tokens only — smaller payload than `select("*")`. */
const USER_DESIGN_TOKEN_COLUMNS =
  "font_family,primary_font_family,secondary_font_family,background_style,button_background,card_style,button_text,button_border,text_color,social_icon_color,template_name";

type UserDesignTokenRow = {
  username?: string | null;
  font_family?: string | null;
  primary_font_family?: string | null;
  secondary_font_family?: string | null;
  background_style?: string | null;
  button_background?: string | null;
  button_text?: string | null;
  button_border?: string | null;
  text_color?: string | null;
  social_icon_color?: string | null;
  template_name?: string | null;
  card_style?: string | null;
};

function mapUserDesignTokenRow(row: UserDesignTokenRow) {
  const {
    username,
    font_family,
    primary_font_family,
    secondary_font_family,
    background_style,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    template_name,
    card_style,
  } = row;
  return {
    username: username || undefined,
    fontFamily: font_family,
    primaryFontFamily: primary_font_family,
    secondaryFontFamily: secondary_font_family,
    primaryColor: background_style || "",
    secondaryColor: button_background || "#e6e7eb",
    tertiaryColor: button_text || "",
    templateName: template_name,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    template_name,
    font_family,
    primary_font_family,
    secondary_font_family,
    background_style,
    card_style,
  };
}

async function fetchUserDesignTokenRow(
  column: "username" | "user_id",
  value: string,
  client: SupabaseClient = supabase,
  signal?: AbortSignal,
  includeUsername = false,
) {
  if (!value) return null;
  try {
    const columns = includeUsername
      ? `username,${USER_DESIGN_TOKEN_COLUMNS}`
      : USER_DESIGN_TOKEN_COLUMNS;
    let query = client.from("user").select(columns).eq(column, value).limit(1);
    if (signal) {
      query = query.abortSignal(signal);
    }
    const { data, error } = await query;
    if (error || !data?.length) return null;
    return mapUserDesignTokenRow(data[0] as UserDesignTokenRow);
  } catch {
    return null;
  }
}

/**
 * Fetches only design-related columns for a username. Use for fast first paint (e.g. follower preview)
 * while `getUserAndCheckExistence` / full profile loads in parallel.
 */
export async function getUserDesignTokensOnly(
  username: string,
  client: SupabaseClient = supabase,
  signal?: AbortSignal
) {
  return fetchUserDesignTokenRow("username", username, client, signal);
}

/**
 * Fetches design tokens by creator `user_id` (e.g. from `all_products.user_id`).
 * Includes `username` so callers can warm the design-token cache.
 */
export async function getUserDesignTokensByUserId(
  userId: string,
  client: SupabaseClient = supabase,
  signal?: AbortSignal
) {
  return fetchUserDesignTokenRow("user_id", userId, client, signal, true);
}

export async function getFiltersAndHighligts(
  user_id: any,
  username: any,
  client: SupabaseClient = supabase
) {
  const activeFiltersArray = ["All"];
  const highlightsArray: unknown[] = [];

  // Independent selects — run in parallel (no cross-dependency).
  const [activeFiltersSettled, highlightsSettled] = await Promise.allSettled([
    client.from(username).select("type").eq("user_id", user_id),
    client
      .from(username)
      .select("content_category")
      .eq("type", "HIGHLIGHTS")
      .eq("user_id", user_id),
  ]);

  if (activeFiltersSettled.status === "fulfilled") {
    const rows = activeFiltersSettled.value?.data;
    if (rows?.length) {
      const activeFilters = new Set(rows.map((obj: any) => obj.type));
      activeFiltersArray.push(...(Array.from(activeFilters) as string[]));
    }
  }

  if (highlightsSettled.status === "fulfilled") {
    const rows = highlightsSettled.value?.data;
    if (rows?.length) {
      const highlights = new Set(
        rows.map((obj: any) => obj.content_category).filter(Boolean),
      );
      highlightsArray.push(...highlights);
    }
  }

  return { activeFiltersArray, highlightsArray };
}

export async function getStats(
  user_id: any,
  username: any,
  client: SupabaseClient = supabase
) {
  let res: any = {
    yesterday: false,
    yesterdayShop: false,
    week: false,
    weekShop: false,
    shopLinks: false,
  };

  const today = getTodayDate();

  // Get yesterday's date
  const yesterdayDate = getCustomSubtractDate(1);
  const sevenDayDate = getCustomSubtractDate(7);

  // All five probes are independent — parallelize to cut LiB complete-page waterfall.
  const [yesterdayRes, yesterdayShopRes, weekRes, weekShopRes, shopLinksRes] =
    await Promise.all([
      client.rpc("get_storiesfeedcountonee", {
        userid: user_id,
        query_str: "",
        user_name: username,
        start_date: yesterdayDate,
        end_date: today,
      }),
      client.rpc("get_storiesfeedcountshopneee", {
        userid: user_id,
        query_str: "",
        user_name: username,
        start_date: yesterdayDate,
        end_date: today,
      }),
      client.rpc("get_storiesfeedcountonee", {
        userid: user_id,
        query_str: "",
        user_name: username,
        start_date: sevenDayDate,
        end_date: today,
      }),
      client.rpc("get_storiesfeedcountshopneee", {
        userid: user_id,
        query_str: "",
        user_name: username,
        start_date: sevenDayDate,
        end_date: today,
      }),
      client.from(`${username}`).select("*").neq("shop_link", "").limit(1),
    ]);

  const yesterday = yesterdayRes.data;
  const yesterdayShop = yesterdayShopRes.data;
  const week = weekRes.data;
  const weekShop = weekShopRes.data;
  const shopLinks = shopLinksRes.data;

  if (yesterday && yesterday[0].count) {
    res.yesterday = true;
  }
  if (week && week[0].count) {
    res.week = true;
  }
  if (yesterdayShop && yesterdayShop[0].count) {
    res.yesterdayShop = true;
  }
  if (weekShop && weekShop[0].count) {
    res.weekShop = true;
  }
  if (shopLinks && shopLinks.length) {
    res.shopLinks = true;
  }
  return res;
}

export async function checkIpAddress(user_id: any) {
  // const res = await axios.get("https://api.ipify.org/?format=json");
  // const {data}=await supabase.from("analytics").select("*").eq("ip",res.data.ip)
  // if(data){
  //   if(data.length===0){
  //     return true
  //   }else{
  //     return false
  //   }
  // }else{
  //   return false
  // }
}

export const extractDomains = (urls: string[]) => {
  const domains = urls
    .filter(
      (url) =>
        url.includes("http") ||
        url.includes("https") ||
        url.includes("www") ||
        url.includes("WWW") ||
        url.includes(".com")
    )
    .map((url) => {
      try {
        const hostname = new URL(url).hostname;
        return hostname.startsWith("www.") ? hostname.slice(4) : hostname;
      } catch (error) {
        return url;
      }
    });

  return [...new Set(domains)];
};

export function getPostTitle(post: any, type: string): string {
  let title = "";
  if (post.product_image && post.product_image !== "") {
    title = (post.product_name || post.shop_title) || "";
  } else if (post.platform === "MISC-content") {
    title = (post.content_title || post.shop_title) || "";
  } else if (type === "content" || type === "query-content") {
    title = post.content_title || "";
  } else if (type === "query-links" || type === "links") {
    title = post.shop_title || post.product_name || post.table_name || "";
  } else if (type === "MAIL") {
    title = post.content_title || post.product_name || "";
  } else if (type === "product-bank") {
    title = post.shop_title || post.table_name || "";
  } else {
    title = post.shop_title || post.content_title || post.product_name || "";
  }

  if (isInstagramHandleLikeTitle(title, post)) {
    return displayFeedCardTitle(post);
  }
  return sanitizePublicCardTitle(title, post) || title || "";
}


export function reorder<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}


/**
 * When false, `type === "campaign"` rows must not appear on link-in-bio,
 * website template, public, or dashboard landing stacks
 * (`user.active_campaign` / Email Campaigns product flag).
 * Prefer `userId` when available (dashboard); otherwise resolve by `username`.
 * Pass `knownActiveCampaign` when the caller already loaded `user.active_campaign`
 * to skip the extra round-trip.
 */
export async function isLandingEmailCampaignsEnabledForUsername(
  username: string | undefined | null,
  client: SupabaseClient = supabase,
  userId?: string | null,
  knownActiveCampaign?: boolean | null,
): Promise<boolean> {
  if (typeof knownActiveCampaign === "boolean") {
    return knownActiveCampaign;
  }
  const uid = String(userId ?? "").trim();
  if (uid) {
    const { data: rowById, error: errById } = await client
      .from("user")
      .select("active_campaign")
      .eq("user_id", uid)
      .maybeSingle();
    if (errById || rowById == null) return false;
    return Boolean(
      (rowById as { active_campaign?: unknown }).active_campaign,
    );
  }
  const un = String(username ?? "").trim();
  if (!un) return false;
  const { data: row, error } = await client
    .from("user")
    .select("active_campaign")
    .eq("username", un)
    .maybeSingle();
  if (error || row == null) return false;
  return Boolean((row as { active_campaign?: unknown }).active_campaign);
}

export type StayUpToDateFetchOptions = {
  /** Skip `user.active_campaign` round-trip when already known from a prior user read. */
  activeCampaign?: boolean;
  /**
   * Preloaded `user_links` rows (landing-page type) for empty-state enrich.
   * When provided (including `[]`), skips the enrich fetch.
   */
  landingPageLinks?: Array<{
    collection_name?: string | null;
    parent_id?: string | number | null;
  }> | null;
};

/**
 * Fetches stay-up-to-date components by username so the query can run in
 * parallel with profile (e.g. as soon as username is available from URL).
 * Ensure stayuptodate_components has an index on username for performance.
 * user_id is optional; when provided and result is empty, updates controls_live.
 */
export async function getStayUpToDateComponents(
  username: any,
  client: SupabaseClient = supabase,
  userId?: string | null,
  options?: StayUpToDateFetchOptions,
) {
  if (!username) {
    return {
      order: [],
      data: [],
      showingComponents: [],
      archiveComponents: [],
    };
  }
  let componentsOrder: any = [];
  let showingComponents: any = [];
  let archiveComponents: any = [];

  const campaignsOnPromise = isLandingEmailCampaignsEnabledForUsername(
    username,
    client,
    userId,
    options?.activeCampaign,
  ).catch(() => false);

  const { data, error }: any = await client
    .from("stayuptodate_components")
    .select("*")
    .eq("username", username)
    .neq("status", "deleted")
    .order("index", { ascending: false });

  const safeData = data ?? [];
  const landingEmailCampaignsOn = await campaignsOnPromise;
  if (safeData.length) {
    const rowUserId = String(userId ?? "").trim() || safeData[0]?.user_id;
    if (rowUserId) {
      await enrichLinksSectionEmptyState(
        safeData,
        rowUserId,
        "landing-page",
        client,
        options?.landingPageLinks,
      );
    }
    for (let i of safeData) {
      if (isHiddenComponent(i) || isProductCollectionType(i)) continue;
      componentsOrder.push(i.name);
      const visibleToViewer = shouldShowToViewer(i);
      if (!visibleToViewer) {
        // if (i.display_name === "Newsletter") {
        //   if (isFilloutOn) {
        //     archiveComponents.push(i);
        //   }
        // } else {
          archiveComponents.push(i);
        // }
      } else {
        // if (i.display_name === "Newsletter") {
        //   if (isFilloutOn) {
        //     archiveComponents.push(i);
        //   }
        // } else {
        const isCampaign =
          String((i as { type?: string }).type ?? "").trim() === "campaign";
        if (isCampaign && !landingEmailCampaignsOn) {
          // Omit from live landing; row remains in `data` for tooling / Email Campaigns.
        } else {
          showingComponents.push(i);
        }
        // }
      }
    }
  }
  archiveComponents = sortArchivedComponents(archiveComponents);
  if (safeData.length === 0 && username) {
    // Only write when the stored value actually differs.
    const { data: controlsRow } = await client
      .from("controls_live")
      .select("initial_content2")
      .eq("username", username)
      .maybeSingle();
    if (String(controlsRow?.initial_content2 ?? "") !== "All") {
      await client
        .from("controls_live")
        .update({ initial_content2: "All" })
        .eq("username", username);
    }
  }
  return {
    order: componentsOrder,
    // data: safeData.filter((item: any) =>
    //   item.display_name === "Newsletter" ? isFilloutOn : true
    // ),
    data: safeData.filter(
      (item: any) => !isHiddenComponent(item) && !isProductCollectionType(item)
    ),
    showingComponents: showingComponents,
    archiveComponents: archiveComponents,
  };
}

/**
 * Website template components — same shape as {@link getStayUpToDateComponents}
 * but reads `template_components` (decoupled from link-in-bio).
 */
export async function getTemplateComponents(
  username: any,
  client: SupabaseClient = supabase,
  userId?: string | null,
) {
  if (!username) {
    return {
      order: [],
      data: [],
      showingComponents: [],
      archiveComponents: [],
    };
  }
  const componentsOrder: any[] = [];
  const showingComponents: any[] = [];
  const archiveComponents: any[] = [];

  let templateQuery = client
    .from("template_components")
    .select("*")
    .neq("status", "deleted")
    .order("index", { ascending: false });

  if (userId?.trim()) {
    templateQuery = templateQuery.eq("user_id", userId.trim());
  } else {
    templateQuery = templateQuery.eq("username", username);
  }

  const { data }: any = await templateQuery;

  const safeData = data ?? [];

  if (safeData.length) {
    for (const i of safeData) {
      componentsOrder.push(i.name);
      const visibleToViewer = shouldShowToViewer(i);
      if (!visibleToViewer) {
        archiveComponents.push(i);
      } else {
        // Website template is not gated on `user.active_campaign`.
        showingComponents.push(i);
      }
    }
  }

  return {
    order: componentsOrder,
    data: safeData,
    showingComponents,
    archiveComponents,
  };
}

function isCampaignComponentRow(row: { type?: unknown } | null | undefined): boolean {
  return String(row?.type ?? "").trim() === "campaign";
}

/**
 * Website Link in Bio loads `template_components`, which also holds the
 * Newsletter campaign used by Home / Newsletter. Drop those rows from the
 * LiB stack so the default Weekly Newsletter is not shown there.
 */
export function omitCampaignsFromWebsiteLinkInBio<T extends {
  showingComponents?: unknown[];
}>(result: T | null | undefined): T | null | undefined {
  if (result == null) return result;
  const showing = Array.isArray(result.showingComponents)
    ? result.showingComponents.filter(
        (row) => !isCampaignComponentRow(row as { type?: unknown }),
      )
    : [];
  return { ...result, showingComponents: showing };
}

export async function getEmbedComponents(
  username: any,
  client: SupabaseClient = supabase,
  userId?: string | null,
  options?: StayUpToDateFetchOptions,
) {
  if (!username) {
    return {
      order: [],
      data: [],
      showingComponents: [],
      archiveComponents: [],
    };
  }
  let componentsOrder: any = [];
  let showingComponents: any = [];
  let archiveComponents: any = [];

  const { data, error }: any = await client
    .from("embed_components")
    .select("*")
    .eq("username", username)
    .neq("status", "deleted")
    .order("index",{ ascending: false });
  const embedRows = Array.isArray(data) ? data : [];
  const landingEmailCampaignsOn =
    await isLandingEmailCampaignsEnabledForUsername(
      username,
      client,
      userId,
      options?.activeCampaign,
    );
  if (embedRows.length) {
    const rowUserId = String(userId ?? "").trim() || embedRows[0]?.user_id;
    if (rowUserId) {
      await enrichLinksSectionEmptyState(
        embedRows,
        rowUserId,
        "embed-search",
        client,
        options?.landingPageLinks,
      );
    }
    for (let i of embedRows) {
      if (isHiddenComponent(i) || isProductCollectionType(i)) continue;
      componentsOrder.push(i.name);
      const visibleToViewer = shouldShowToViewer(i);
      if (!visibleToViewer) {
        archiveComponents.push(i);
      } else {
        const isCampaign =
          String((i as { type?: string }).type ?? "").trim() === "campaign";
        if (isCampaign && !landingEmailCampaignsOn) {
          // Omit from live embed landing when Email Campaigns is off.
        } else {
          showingComponents.push(i);
        }
      }
    }
  }
  archiveComponents = sortArchivedComponents(archiveComponents);
  if (embedRows.length === 0) {
    const { data: controlsRow } = await client
      .from("controls_live")
      .select("initial_content2")
      .eq("username", username)
      .maybeSingle();
    if (String(controlsRow?.initial_content2 ?? "") !== "All") {
      await client
        .from("controls_live")
        .update({ initial_content2: "All" })
        .eq("username", username);
    }
  }
  return {
    order: componentsOrder,
    // data: data.filter((item: any) =>
    //   item.display_name === "Newsletter" ? isFilloutOn : true
    // ),
    data: embedRows.filter(
      (item: any) => !isHiddenComponent(item) && !isProductCollectionType(item)
    ),
    showingComponents: showingComponents,
    archiveComponents: archiveComponents,
  };
}

export async function signOut() {
  // Only clear auth-related items, not everything (to avoid triggering storage events unnecessarily)
  // This prevents race conditions with the useAuth hook's storage event listener
  localStorage.removeItem("member");
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("admin");
  // Clear sessionStorage to prevent stale cache
  sessionStorage.clear();

}

export function getProductFilter(selectedProductFilter: string,) {
  if (selectedProductFilter && selectedProductFilter == "Post") {
    return ['FEED', 'REELS']
  }
  else if (selectedProductFilter && selectedProductFilter == "Story") {
    return ['STORY', 'HIGHLIGHTS']
  }
  else {
    return ['FEED', 'REELS', 'STORY', 'HIGHLIGHTS']
  }
}


export function getPlatformName(platform: string) {
  switch (platform) {
    case "Post":
      return "Instagram Posts";
    case "Story":
      return "Instagram Stories";
    case "tiktok":
      return "TikTok";
    case "youtube":
      return "YouTube";
    case "pinterest":
      return "Pinterest";
    case "newsletter":
      return "Newsletter";
    case "amazon":
      return "Amazon";
    case "shopmy":
      return "ShopMy";
    case "shop":
      return "Shop";
    case "podcast":
      return "Podcast";
    case "discord":
      return "Discord";
    case "snapchat":
      return "Snapchat";
    case "spotify":
      return "Spotify";
    case "applepodcast":
      return "Apple Podcast";
    case "twitter":
      return "X";
    case "ltk":
      return "LTK";
    case "amazon":
      return "Amazon";
    case "shopmy":
      return "ShopMy";
    case 'instagram':
      return "Instagram";
    case "linkedin":
      return "LinkedIn";
    default:
      return platform;
  }
}


export async function checkLandingPage(user_id: any) {
  // Stay rows + current controls in parallel; only write when value must change.
  const [stayRes, controlsRes] = await Promise.all([
    supabase
      .from("stayuptodate_components")
      .select("id,type,status")
      .eq("user_id", user_id)
      .eq("status", "active"),
    supabase
      .from("controls_live")
      .select("initial_content2")
      .eq("user_id", user_id)
      .maybeSingle(),
  ]);

  const landingRows = (Array.isArray(stayRes.data) ? stayRes.data : []).filter(
    (item: any) => !isProductCollectionType(item),
  );

  const desired =
    landingRows.length > 0 ? "Landing Page" : "All";
  const current = String(controlsRes.data?.initial_content2 ?? "");
  if (current === desired) return;

  await supabase
    .from("controls_live")
    .update({ initial_content2: desired })
    .eq("user_id", user_id);
}

export function getCustomDateRange(activeTab: number, customStartDate: any, customEndDate: any) {
  let endDate: any;
  let startDate: any;
  if (activeTab !== 1 && activeTab !== 2) {
    endDate = getCustomAddDate(1);
    startDate = getCustomSubtractDate(activeTab);
  } else {
    if (activeTab === 2) {
      endDate = getCustomAddDate(1);
      startDate = getCustomSubtractDate(100000);
    } else {
      startDate = customStartDate ? customStartDate : "";
      endDate = customEndDate ? customEndDate : "";
    }
  }
  return { startDate, endDate };
}


export  const isHexDark = (hex: string) => {
  if (!hex) return false;
  const clean = hex.replace('#', '');
  const full = clean.length === 3
    ? clean.split('').map((c) => c + c).join('')
    : clean;
  if (full.length !== 6) return false;
  const r = parseInt(full.substring(0, 2), 16);
  const g = parseInt(full.substring(2, 4), 16);
  const b = parseInt(full.substring(4, 6), 16);
  // YIQ luma approximation
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq < 150; // threshold; lower means darker
};

/** Normalize a hex color for equality/contrast checks. Returns null while incomplete/invalid. */
export function normalizeHexColor(color: string): string | null {
  const trimmed = String(color || "").trim().toLowerCase();
  const short = /^#([0-9a-f]{3})$/.exec(trimmed);
  if (short) {
    const [r, g, b] = short[1].split("");
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  const long = /^#([0-9a-f]{6})$/.exec(trimmed);
  if (long) return `#${long[1]}`;
  return null;
}

export function areSameHexColor(a: string, b: string): boolean {
  const na = normalizeHexColor(a);
  const nb = normalizeHexColor(b);
  if (!na || !nb) return false;
  return na === nb;
}

/** Parse #rgb/#rrggbb → [r,g,b] 0–255, or null if incomplete/invalid. */
function hexToRgb(color: string): [number, number, number] | null {
  const hex = normalizeHexColor(color);
  if (!hex) return null;
  return [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ];
}

/** sRGB channel → linear value for WCAG relative luminance. */
function srgbChannelToLinear(channel: number): number {
  const c = channel / 255;
  return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

function relativeLuminance(color: string): number | null {
  const rgb = hexToRgb(color);
  if (!rgb) return null;
  const [r, g, b] = rgb.map(srgbChannelToLinear);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** WCAG contrast ratio (1–21). Returns null while either color is incomplete. */
export function getContrastRatio(a: string, b: string): number | null {
  const l1 = relativeLuminance(a);
  const l2 = relativeLuminance(b);
  if (l1 == null || l2 == null) return null;
  const lighter = Math.max(l1, l2);
  const darker = Math.min(l1, l2);
  return (lighter + 0.05) / (darker + 0.05);
}

/**
 * Soft default for custom palettes — only blocks near-blending pairs.
 * Callers can pass a stricter `minRatio` (e.g. 3 or 4.5 for WCAG AA).
 */
export const MIN_COLOR_CONTRAST_RATIO = 1.3;

/**
 * Returns true when two hex colors are complete and their contrast is below
 * `minRatio`. Incomplete/invalid hex returns false so typing is not blocked.
 */
export function hasInsufficientContrast(
  a: string,
  b: string,
  minRatio: number = MIN_COLOR_CONTRAST_RATIO,
): boolean {
  const ratio = getContrastRatio(a, b);
  if (ratio == null) return false;
  return ratio < minRatio;
}